import { Field, FieldProps, FormikProps } from 'formik';
import * as React from 'react';
import { FieldRow, StyledFormGroup } from '../../../../components/shared';

import { Option, PeopleProfileInstitutionFormType, PeopleProfileOrganisationFormType } from '../../../../utils/types';
import { OrganisationsCard } from './organisationsCard';
import { PersonDetailsFormType } from '../forms/PersonDetailsForm';

export type FormType = PersonDetailsFormType & {
  typeId: Option | undefined;
  portal: string;

  dateOfBirth: Date | null;
  emisNumber: number | undefined;
  name: string;

  primaryInstitutionId: Option | undefined;
  institutionIds: Option[];
  associatedInstitutions: PeopleProfileInstitutionFormType[];
  associatedOrganisations: PeopleProfileOrganisationFormType[];
};

type Props = {
  formikProps: FormikProps<FormType>;
  userRoles?: any;
};

const FieldsForPeople: React.FC<Props> = props => {
  const { formikProps } = props;

  // const canLinkInstitutions = ['INSTITUTION_ADMIN', 'INSTITUTION_MEMBER'].some(
  //   (item: any) => userRoles && userRoles.includes(item)
  // );

  return (
    <React.Fragment>
      <FieldRow>
        <Field
          name="emailAddress"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Email Address" mr={4} />
          )}
        />
        <Field
          name="designation"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Designation" mr={4} />
          )}
        />
        <Field
          name="organisation"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Organisation" mr={4} />
          )}
        />
      </FieldRow>
      <OrganisationsCard
        formikProps={formikProps}
        // viewMode={formikProps.values.portal !== 'admin'}
        currentOrganisationsOnly={formikProps.values.portal !== 'admin'}
      />
    </React.Fragment>
  );
};

export default FieldsForPeople;
